import { Component, OnChanges, SimpleChanges, Input, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';
import { CustomFieldRenderer } from 'src/app/shared/services/lw-ui-rule/ltms-custom-field-renderer-v2';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { CommonService } from 'src/app/shared/services/lw-ui-rule/common.service';
import { LwActionsExecutor } from 'src/app/shared/services/lw-ui-rule/lw-action-executor';
import { LtmsEventHandlerService } from 'src/app/shared/services/ltms-event-handler/ltms-event-handler.service';
import { LtmsDataSource } from 'src/app/shared/services/lw-ui-rule/ltms-data-source';
import { LwComponentRenderer } from 'src/app/shared/services/lw-elements-renderer/lw-component-renderer';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { FileUploadService } from 'src/app/shared/services/file-upload/file-upload.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { HuddlesService } from 'src/app/shared/services/huddle/huddles.service';
import { DomSanitizer  } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
@Component({
    selector: 'suggestion-edit-modal',
    standalone: true,
    templateUrl: './suggestion-edit-modal.component.html',
    styleUrl: './suggestion-edit-modal.component.scss'
})
export class SuggestionEditModalComponent implements OnChanges {
  @Input() config: any = {}
  @Output() onCancel = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  escalationDetail: any = {}
  mode: any = '';
  modalHeader: any = '';
  tableColumns: any = []
  escalationsToMerge: any = {}
  brandDetail: any = {}
  escalationId: any = {}
  showEditModal: boolean = false;
  parentBrand: any = null;
  constructor(
    private huddlesService: HuddlesService,
    private _helpers: HelpersService,
    private _feedService: FeedsService,
    private commonService: CommonService,
    private LwActionsExecutor: LwActionsExecutor,
    private _ltmsEvent: LtmsEventHandlerService,
    private LtmsDataSource: LtmsDataSource,
    private lwComponentRenderer: LwComponentRenderer,
    private _utils: UtilsService,
    private _uploadService: FileUploadService,
    private _domSanitizer: DomSanitizer
  ) { }


  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config']) {
      this.showEditModal = true;
      this.escalationDetail = this.config
      this.mode = _.get(this.escalationDetail, "mode");
      this.modalHeader = _.get(this.escalationDetail, "modalHeader");
      this.tableColumns = _.get(this.escalationDetail, "fieldDefinitionsForList");
      this.escalationsToMerge = Object.values(_.get(this.escalationDetail, "mergedData") || {});
      this.brandDetail = _.get(this.escalationDetail, "brandDetail");
      var fieldDefinitionsToRender = _.get(this.escalationDetail, "fieldDefinitions") || this.brandDetail.field_definitions;
      this.escalationId = _.get(this.escalationDetail, "issueDetail._id");
      var accessDetail: any = this._helpers.getLoggedInAccessLevelAndValue();
      this.parentBrand = _.get(this.escalationDetail, "parentBrand");
      // Filter out the field definition which have visibility_config.edit as false
      var fieldDefinitions = _.filter(fieldDefinitionsToRender, function (fieldDefinition) {
        if (_.get(fieldDefinition, "datasource.rules.isAccessRule")) {
          // If no access details: Set rhs to null: No data should be populated
          fieldDefinition["datasource"]["rules"]["rhs"] = (_.isEmpty(accessDetail)) ? null : accessDetail?.level;
        }
        return (_.get(fieldDefinition, "visibility_config.edit") != false);
      });

      var parentGroup = _.filter(fieldDefinitions, { "group_id": null });
      parentGroup = (parentGroup && parentGroup.length) ? parentGroup[0] : null;
      if (parentGroup) {
        // const params: any = this.tempParams;
        var groupKey = _.get(parentGroup, "field_id");
        var params = {
          "issueId": " ",
          "issueDetail": _.get(this.escalationDetail, "issueDetail"),
          "brandDetail": { 
            "field_definitions": Helpers.deepClone(fieldDefinitions),
            "unique_custom_parameter_id": "tempIdForMergeEscalation",
            "_id": this.parentBrand?._id,
            "status_list_for_huddle": this.parentBrand?.status_list_for_huddle
          },
          "showSubmit": false,
          "elementId": "huddle_merge_escalation_container",
          "action": {
            "action": "renderOnAccordion",
            "options": {
              "group_id": groupKey
            }
          }
        }

        const services: any = {
          _helpers: this._helpers,
          LtmsDataSource: this.LtmsDataSource,
          lwComponentRenderer: this.lwComponentRenderer,
          _utils: this._utils,
          _uploadService: this._uploadService,
          _feedService: this._feedService,
          LwActionsExecutor: this.LwActionsExecutor,
          _ltmsEvent: this._ltmsEvent,
          _domSanitizer: this._domSanitizer,
          SecurityContext: SecurityContext
        }
        const ltmsCustomField: any = new CustomFieldRenderer(params, services)
        this._ltmsEvent.remove('custom-parameter-validate-status-escalation-edit');
        this._ltmsEvent.listen('custom-parameter-validate-status-escalation-edit', (event: any) => {
          if (_.get(this.escalationDetail.brandDetail, "field_definitions")) {
            this.updateDataForObjectType(event.data, this.escalationDetail.brandDetail.field_definitions);
            this.merge(event.data)
          }
        });
      }
    }
  }

  merge(data) {
    let params: any = this.prepareDataForMerge(data);
    params = (this.escalationDetail.mode == "Merge") ? this.prepareDataForMerge(data) : this.prepareDataToUpdate(data);
    if (params) {
      if (this.escalationDetail.mode == "Merge") {
        this.huddlesService.mergeEscalation(params).subscribe((response) => {
          if (_.get(response, "error")) {
            Helpers.smallAlertBox("Error", response.error, "error", 3500);
          } else {
            // $('#newHuddleModal').modal('toggle');
            Helpers.smallAlertBox("Success", "Suggestions merged successfully", "success", 3500);
          }
          this.cancel()
        },(error)=>{
          Helpers.smallAlertBox("Error", "Error occured while merging suggestions", "error", 3500);
          this.cancel()
        });
      } else if (this.escalationDetail.mode == "Update") {
        this._feedService.updateCustomParameter(this.escalationId, params).subscribe((response) => {
          if (_.get(response, "data.code") == 0) {
            Helpers.smallAlertBox("Success", "Suggestion updated successfully. Updated details may take some time to reflect", "success", 3500);
          } else if (_.get(response, "data.code") == 4022) {
            Helpers.smallAlertBox("Warning", "Data already updated.", "warn");
          }
          this.cancel();
        },(error)=>{
          Helpers.smallAlertBox("Error", "Error occured while updating suggestion", "error", 3500);
          this.cancel()
        });
      }
    } else {
      Helpers.smallAlertBox("Warning", "Can't merge escalations as manager doesn't have a dynamic project access.", "warn", 3500);
    }
  }

  prepareDataForMerge(data) {
    var accessDetail = this._helpers.getLoggedInAccessLevelAndValue();
    if (accessDetail) {
      // var levelName = getHierarchyNameByLevel(accessDetail.level);
      var params = {
        // brandDetail refers to the Escalation Brand
        "brandId": Helpers.brandDetails._id, // This will the Id of Huddle Main Brand
        "appId": this.getAppId(),
        "description": _.get(data, "tag_ltms_custom_field_suggestions_for_process_imporvement_item_description"),
        "feedIdList": this.getIdsOfEscalationsToMerge(),
        "hierarchyLevel": accessDetail.level,
        "hierarchyValue": accessDetail.value, // levelName,
        "tags": (data || {})
      };
      // update tag_brand_id within tags: This will be the Escalation's brand id
      params["tags"]["tag_brand_id"] = this.escalationDetail.brandDetail._id;
      return params;
    } else {
      return null;
    }
  }

  prepareDataToUpdate(data) {
    var params = { "customFeed": data }
    return params;
  }

  updateDataForObjectType(data, fieldDefinitions) {
    var fieldId = null;
    var fieldDefinitionMap = this.prepareMap(fieldDefinitions, 'field_id');
    var displayField: any = null;
    var valueField: any = null;
    var dataToModify: any = null;

    for (let fieldId in data) {
      // If value of key is an object then we need to check for the pattern to save in
      if (_.isObject(data[fieldId])) {
        dataToModify = data[fieldId];
        // If data has object, get the field definition for the fieldId: This will provide the detail to save data in.
        let fieldDefinition = fieldDefinitionMap[fieldId];
        if (_.get(fieldDefinition, "datasource.options.data_to_save_in") && _.isObject(fieldDefinition.datasource.options.data_to_save_in) && !_.isEmpty(fieldDefinition.datasource.options.data_to_save_in)) {
          // field definition to update for Display field 
          displayField = _.get(fieldDefinition, "datasource.options.data_to_save_in.display_field");
          valueField = _.get(fieldDefinition, "datasource.options.data_to_save_in.value_field");

          data[displayField] = dataToModify[_.get(fieldDefinition, "datasource.options.display_field")];
          data[valueField] = dataToModify[_.get(fieldDefinition, "datasource.options.value_field")];
        }
      }
    }
  }

  prepareMap(data, key) {
    var dataMap = {};
    _.each(data, function (d) {
      dataMap[d[key]] = d;
    })
    return dataMap;
  }

  getIdsOfEscalationsToMerge() {
    return (_.map(Helpers.deepClone(this.escalationsToMerge), '_id'));
  }

  getAppId() {
    var mainProjectHuddleConfig = _.get(Helpers, "brandDetails.action_management_configuration.huddle");
    // Get all the configs of a brand
    var moduleConfig = Object.values(_.get(mainProjectHuddleConfig, "modules") || {});
    var escalationHuddleConfigInMainProject = _.filter(moduleConfig, (d) => {
      return (_.get(d, "config.brand_id") == this.brandDetail._id)
    })
    return _.get(escalationHuddleConfigInMainProject, "0.config.app_id")
  }


  triggerMerge() {
    this._ltmsEvent.emit("submit-custom-parameter", { "unique_custom_parameter_id": "tempIdForMergeEscalation", "event_to_trigger": ("custom-parameter-validate-status-escalation-edit") })
  }

  closeEditModal() {
    this.showEditModal = false;
    this.onClose.emit();
  }
  cancel() {
    this.showEditModal = false;
    this.onCancel.emit()
  }
  
  isScrollEnabled() {
    const el = document.getElementById('suggestion-edit-modal-body');
    if (el) {
      return (el.offsetHeight < el.scrollHeight)
    } else {
      return false
    }
  }


  triggerUpdate(){

  }
}
